<template>
  <div>
  </div>
</template>

<script lang="ts">
import {
  Component, Prop, Vue, Inject
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const PostEnquiryModule = namespace('postEnquiryModule');

@Component
export default class PostEnquirySettingsComponent extends Vue {
  @PostEnquiryModule.Action public submitEnquiryData;

  @PostEnquiryModule.Action public retrieveManufacturer;

  @PostEnquiryModule.Action public submitEnquiryVehicles;

  @PostEnquiryModule.Action public submitPolicyDetails;

  @PostEnquiryModule.Action public submitTestDriveAppointmentDetails;

  @PostEnquiryModule.Action public submitRetailerSelectionDetails;

  @Prop({ default: null })
  public enquiry!: any;

  public async created() {
    this.submitEnquiryData(this.enquiry);
    this.retrieveManufacturer(this.enquiry.vehicles[0]);
    this.submitEnquiryVehicles(this.enquiry.vehicles);
    this.submitPolicyDetails(this.enquiry.policyDetails);
    this.submitRetailerSelectionDetails(this.enquiry);
    this.submitTestDriveAppointmentDetails(this.enquiry);
  }
}
</script>
